import * as React from "react";
import ImgFrom from "react-image";
// import { pure } from 'recompose'
import * as Utils from "@Cyclope-Utils/index";
import * as jwt_decode from "jwt-decode";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  {
    /**  <ImgFrom src={localUrl+"?nocache="+ noCache.generate()} loader={<div className="imageBrokenLoader"/>} unloader={<div className="imageIsBroken"/>} alt={name} className={classnames} crossorigin="anonymous"/> */
  }
  const { localUrl, name, classnames } = props;
  /**
   * @description : Retourne un objet de type any { utilisateur }
   * @const
   * @name data
   * @type { any }
   */
  const data: any =
    Utils.localStorageIsKeyExist() &&
    jwt_decode(Utils.localStorageIsKeyExist());

  const user: string = data && data.sub;
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <ImgFrom
      src={localUrl && localUrl + "/" + user}
      loader={<div className="imageBrokenLoader" />}
      unloader={<div className="imageIsBroken" />}
      alt={name}
      className={classnames}
      crossorigin="anonymous"
    />
  );
};

// interface
interface ComponentInterface {
  localUrl?: any;
  name?: string;
  classnames?: any;
  id?: string;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/stream-live/component.tsx